import { render, staticRenderFns } from "./BusinessCase.vue?vue&type=template&id=6f584c67&scoped=true&"
import script from "./BusinessCase.vue?vue&type=script&lang=js&"
export * from "./BusinessCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f584c67",
  null
  
)

export default component.exports